/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-useless-escape */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { ResetPasswordModal } from 'src/components';
import { AlertAdapter, FullScreenLoading, LargeButton, RouterLink } from 'pg-ui-library';
import { ErrorMessage, Form, Formik } from 'formik';
import * as yup from 'yup';

import loginImg from 'src/assets/login.png';
import emailSvg from 'src/assets/email.svg';
import logoSvg from 'src/assets/logo_pride.svg';
import lockSvg from 'src/assets/lock.svg';
import eyeSvg from 'src/assets/eye.svg';
import eyeOffSvg from 'src/assets/eye-off.svg';
import questionSvg from 'src/assets/question.svg';
import { useActions } from 'src/hooks/useActions';

import { useTypedSelector } from 'src/hooks/useTypedSelector';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { IValidateUserSignin } from 'src/interfaces';
import mfaService from 'src/services/mfa.service';
import { getTrustedDeviceToken } from 'src/utils/trustedDevice';
import {
  Container,
  FormContainer,
  ImageContainer,
  Input,
  FooterText,
  LinkContainer,
  FooterContainer,
  LogoContainer,
  MenuContainer,
  BackgroundImage,
  FormTitle,
  Logo,
  FooterLink,
  FooterRouteLink,
  FormInputWrapper,
  InputLabel,
  LoginInput,
  LockIcon,
  QuestionIcon,
  ErrorText,
  ErrorContainer,
  ShowPassword,
  EmailIcon,
  SignUpText,
} from './styles';
import { StoreContextProvider } from './auth.context';
import { SignUpRoleModal } from './components/signup-role-modal';

const Login: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const [forgotPassIsOpen, setForgotPassIsOpen] = useState<boolean>(false);
  const { data, error, loading } = useTypedSelector(state => state.auth);
  const { signinWithTrustedDevice, signinDirect } = useActions();
  const navigate = useNavigate();

  // external manager changes
  const redirectPath = data?.redirectPath;
  const userRole = data?.userRole;

  const [token, setToken] = useLocalStorage('accessToken', null);
  const [modules, setModules] = useLocalStorage('modules', []);
  const [typedUsername, setTypedUsername] = useLocalStorage('typedUsername', '');
  const [userRoleSetting, setUserRoleSetting] = useLocalStorage('userRole', null);
  const location = useLocation();
  const state = location.state as any;
  const from = state?.from?.pathname || '/dashboard';
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState<string>('password');
  const [firstIcon, setFirstIcon] = useState<string>(eyeSvg);
  const [authMethodLoading, setAuthMethodLoading] = useState<boolean>(false);

  const [signUpModalOpen, setSignUpModalOpen] = useState(false);

  const handlePassword = (visible: string) => {
    setIsVisible(visible === 'password' ? 'text' : 'password');
    setFirstIcon(visible === 'password' ? eyeOffSvg : eyeSvg);
  };

  useEffect(() => {
    if (data?.accessToken) {
      setToken(data.accessToken);
      setUserRoleSetting(data?.userRole);
      setModules(data.modules);
    }
  }, [data?.accessToken]);

  useEffect(() => {
    if (token && modules.length) {
      const target = redirectPath || state?.from?.pathname || '/dashboard';
      navigate(target, { replace: true });
    }
  }, [token, modules, redirectPath, userRole]);

  const submit = async (values: IValidateUserSignin) => {
    setAuthMethodLoading(true);
    try {
      let mfaFirst: Awaited<ReturnType<typeof mfaService.validateUserAndPass>>;
      try {
        mfaFirst = await mfaService.validateUserAndPass(values);
      } catch (e: any) {
        if (e?.response?.status === 429) {
          AlertAdapter(
            'Account temporarily locked due to too many failed MFA attempts. Please try again in 1 hour.',
            'error'
          );
          return;
        }
        AlertAdapter(t('login.form.error'), 'error');
        return;
      }

      const preferenceRaw = (mfaFirst as any)?.mfa_preference as string | null | undefined;
      const preference =
        preferenceRaw != null && String(preferenceRaw).trim() !== ''
          ? (String(preferenceRaw).toLowerCase().trim() as 'authenticator' | 'email')
          : null;
      const mfaActivated = Boolean((mfaFirst as any)?.mfa_activated);
      const accessToken = (mfaFirst as any)?.access_token as string | undefined;

      if (accessToken && !mfaActivated) {
        signinDirect({ accessToken, permissions: (mfaFirst as any).permissions || [] });
        return;
      }

      // Authenticator requires OTP — never bypass with trusted device
      const requiresAuthenticatorStep = preference === 'authenticator' || (mfaActivated && preference !== 'email');

      const trustedDeviceToken = getTrustedDeviceToken(values.username);
      if (trustedDeviceToken && !requiresAuthenticatorStep) {
        try {
          await signinWithTrustedDevice({
            username: values.username,
            password: values.password,
            trustedDeviceToken,
          });
          return;
        } catch (e: any) {
          if (e?.response?.status === 429) {
            AlertAdapter(
              'Account temporarily locked due to too many failed MFA attempts. Please try again in 1 hour.',
              'error'
            );
            return;
          }
          // Fall through to MFA page
        }
      }

      navigate('/mfa', {
        state: {
          username: values.username,
          password: values.password,
          preference,
          mfaActivated,
        },
      });
    } finally {
      setAuthMethodLoading(false);
    }
  };

  const handleForgotPassModal = (isOpen: boolean) => {
    setForgotPassIsOpen(!isOpen);
  };

  const validationSchema = yup.object({
    username: yup
      .string()
      .required(t('global.form.required'))
      .matches(/^(?=.*[a-zA-Z])[A-Za-z0-9\-_@.]{4,}$/, t('global.form.invalidFormat')),
    password: yup
      .string()
      .required(t('global.form.required'))
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/, 'Invalid password format'),
  });

  return (
    <>
      {(loading || authMethodLoading) && <FullScreenLoading />}
      <SignUpRoleModal isOpen={signUpModalOpen} setIsOpen={setSignUpModalOpen} />
      <Container>
        <MenuContainer>
          <LogoContainer>
            <Logo src={logoSvg} alt="Pride Global logo" />
          </LogoContainer>
          <FormContainer>
            <FormTitle>{t('login.form.title')}</FormTitle>
            <Formik
              initialValues={{
                username: '',
                password: '',
              }}
              onSubmit={submit}
              validationSchema={validationSchema}
            >
              {({ handleChange, handleSubmit, errors }) => (
                <Form onSubmit={handleSubmit}>
                  <FormInputWrapper>
                    <InputLabel>{t('login.form.email')}</InputLabel>
                    <LoginInput>
                      <EmailIcon src={emailSvg} />
                      <Input
                        id="username"
                        name="username"
                        type="text"
                        placeholder={t('login.form.email')}
                        onChange={handleChange}
                      />
                    </LoginInput>
                  </FormInputWrapper>
                  <FormInputWrapper>
                    <InputLabel>{t('login.form.password')}</InputLabel>
                    <LoginInput>
                      <LockIcon src={lockSvg} />
                      <Input
                        id="password"
                        name="password"
                        type={isVisible}
                        placeholder={t('login.form.password')}
                        onChange={handleChange}
                      />
                      <ShowPassword src={firstIcon} onClick={() => handlePassword(isVisible)} />
                      <div data-cy="question-icon" title={t('login.form.forgotPassword')}>
                        <QuestionIcon src={questionSvg} onClick={() => handleForgotPassModal(forgotPassIsOpen)} />
                      </div>
                    </LoginInput>
                  </FormInputWrapper>
                  <ResetPasswordModal isOpen={forgotPassIsOpen} />
                  <ErrorContainer>
                    {error ? (
                      <ErrorText>{t('login.form.error')}</ErrorText>
                    ) : (
                      <ErrorMessage name={errors.username ? 'username' : 'password'} component={ErrorText} />
                    )}
                  </ErrorContainer>
                  <LargeButton type="submit" style={{ margin: 0, cursor: 'pointer' }}>
                    {t('login.form.button')}
                  </LargeButton>
                </Form>
              )}
            </Formik>
            <SignUpText>{t('signUp.title')}</SignUpText>
            <RouterLink to="/sign-up">{t('signUp.form.button')}</RouterLink>
          </FormContainer>
          <FooterContainer>
            <FooterText>{t('signUp.footer.rights', { year: currentYear })}</FooterText>
            <LinkContainer>
              <FooterRouteLink to="/terms-of-use">Terms of Use</FooterRouteLink>
              <FooterRouteLink to="/privacy-policy">Privacy Policy</FooterRouteLink>
              <FooterRouteLink to="/company-policy">Company Policy</FooterRouteLink>
              <FooterRouteLink to="/cookie-policy">Cookie Policy</FooterRouteLink>
              <FooterLink href="mailto:ESSsupport@prideglobal.com" target="_blank">
                {t('login.footer.support')
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase())}
              </FooterLink>
              <FooterLink href="User.Guide.pdf" target="_blank">
                {t('login.footer.guide')
                  .toLowerCase()
                  .replace(/\b\w/g, char => char.toUpperCase())}
              </FooterLink>
            </LinkContainer>
          </FooterContainer>
        </MenuContainer>
        <ImageContainer>
          <BackgroundImage src={loginImg} alt="Background image" />
        </ImageContainer>
      </Container>
    </>
  );
};

export default function LoginPageWrapper() {
  return (
    <StoreContextProvider>
      <Login />
    </StoreContextProvider>
  );
}
